// extracted by mini-css-extract-plugin
module.exports = {"miniTitle":"MiniTitle_miniTitle__JgOAO"};